// निवड प्रक्रिया — गुण विभागणी (एकूण १०० गुण). Single source of truth used by both the
// applicant-facing गुण विभागणी तक्ता and the officer गुणांकन form.
// Normal item: [label, marks]. Experience section (exp:true) item: [label, वरील(max), आतील(inner)].
export const MARKING_SECTIONS = [
  { title: "१. शैक्षणिक पात्रता", items: [
    ["१२ वी (HSC) उत्तीर्ण", 5], ["पदवी", 2], ["पदव्युत्तर पदवी", 3]] },
  { title: "२. संगणक व डिजिटल साक्षरता", items: [
    ["MSCIT किंवा समकक्ष प्रमाणपत्र", 10], ["सायबर सुरक्षाबाबतचे प्रमाणपत्र", 2], ["ऑनलाईन अर्जप्रक्रिया व संगणक हाताळणी बाबतचे किमान 1 वर्ष अनुभवाचे शासकीय विभाग प्रमुखाचे प्रमाणपत्र", 3]] },
  { title: "३. पायाभूत सुविधा", items: [
    ["किमान १०० चौ.फूट क्षेत्रफळाचे स्वतंत्र कार्यालय (८-अ उतारा / असेसमेंट उतारा / भाडेकरार)", 2], ["दोन संगणक / लॅपटॉप", 2], ["लेझर प्रिंटर", 1], ["स्कॅनर", 1],
    ["बायोमेट्रिक उपकरण", 2], ["वेबकॅम", 1], ["यूपीएस अथवा पर्यायी वीज बॅकअप", 1], ["ब्रॉडबँड इंटरनेट (ग्रामीण १० Mbps, नागरी २० Mbps)", 2], ["सीसीटीव्ही व्यवस्था", 1],
    ["नागरिकांसाठी प्रतीक्षा कक्ष व सेवा शुल्क फलक", 1], ["दिव्यांग व ज्येष्ठ नागरिकांसाठी सुलभ प्रवेश", 1]] },
  { title: "४. आर्थिक क्षमता", items: [
    ["पुरेशी बँक शिल्लक / मुदत ठेव (FD) व इतर गुंतवणूक", 3], ["आर्थिक क्षमता ऐपत (बँक सॉल्वन्सी/गॅरेंटी/तहसीलदार दाखला)", 2], ["मागील २ वर्षांची आयकर विवरणपत्रे (2024-25 व 2025-26)", 3], ["आर्थिक शाश्वतता स्वयंघोषणापत्र", 2]] },
  { title: "५. मुलाखतीद्वारे", items: [
    ["शासकीय सेवांचे ज्ञान व नागरिकाभिमुख सेवावृत्ती", 6],
    ["समस्या सोडविण्याची क्षमता, संवाद कौशल्य व प्रामाणिकपणा व नैतिकता", 8],
    ["डिजीटल प्रणाली हाताळणी व माहिती गोपनियता व डेटा सुरक्षा जागरूकता", 6]] },
  { title: "६. अनुभव", cap: 10, exp: true, items: [
    ["सीएससी ऑपरेटर", 3, 2], ["महा ई सेवा केंद्र ऑपरेटर", 3, 2], ["बँकिंग प्रतिनिधी (BC)", 2, 1], ["ई-गव्हर्नन्स प्रकल्प (वर्क आर्डरसह) / शासकीय सेवा केंद्र कराराचा अनुभव (वर्क आर्डरसह)", 2, 1]] },
  { title: "७. व्यवसाय आराखडा व शाश्वतता", items: [
    ["सेवा विस्तार", 2], ["जनजागृती", 1], ["आर्थिक व्यवहार्यता", 1], ["व्यवसाय नियोजन", 1]] },
  { title: "८. सामाजिक समावेशकता (कमाल ५)", items: [
    ["महिला", 5], ["माजी सैनिक", 5], ["दिव्यांग", 5], ["स्वयंसहाय्यता गट सदस्य", 5], ["स्थानिक उद्योजक", 5]], cap: 5 },
  { title: "९. चारित्र्य पडताळणी", items: [
    ["पोलीस पडताळणी (दोषसिद्धी/फसवणूक नसणे)", 8], ["काळ्या यादीत नसणे", 2]] },
];

// Convert an integer to Devanagari digits (for display, e.g. 10 -> १०).
export const toMr = (n) => String(n).replace(/[0-9]/g, (d) => "०१२३४५६७८९"[d]);

// Total marks for a section header (cap if present, else sum of item marks).
export const sectionTotal = (sec) =>
  sec.cap != null ? sec.cap : sec.items.reduce((a, it) => a + (it[1] || 0), 0);
